import { useState, PropsWithChildren } from "react";
import { DialogResponsive } from "@/components/common/dialogs";

import { User } from "@/types";
import { FormCreateUser } from "./form-create-user";
import { FormUpdateUser } from "./form-update-user";

type FormUserProps = PropsWithChildren & {
  user?: User;
};

export function FormUser({ children, user }: FormUserProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={user ? "Atualizar usuário" : "Novo usuário"}
      description={
        user
          ? "Preencha os campos para atualizar o usuário."
          : "Preencha os campos para criar uma novo usuário."
      }
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
      className="max-w-5xl 2xl:max-w-6xl w-full h-auto"
    >
      {user ? (
        <FormUpdateUser user={user} handleClose={() => setOpen(false)} />
      ) : (
        <FormCreateUser handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
